import * as HttpStatus from 'http-status-codes'

import {
  APISessionExpiredError,
  hasMissingCredentials,
  hasStaffAccessExpired,
  InvalidSessionMessage,
  redirectToSignIn,
} from '@webapp/core/services/SessionExpiry'
import { type IApiError } from '@webapp/services/api'

export { InvalidSessionMessage }

export const redirectOnSessionExpired = (error: IApiError) => {
  const isUnauthorized = error?.status === HttpStatus.UNAUTHORIZED

  if (isUnauthorized && hasMissingCredentials(error.data)) {
    redirectToSignIn()

    throw new APISessionExpiredError(InvalidSessionMessage.MISSING, error.data)
  }

  if (isUnauthorized && hasStaffAccessExpired(error.data)) {
    redirectToSignIn()
    return
  }

  throw error
}
